<template>
  <gallery-cropped :gallery="getPreviewGallery" :crop-by="cropBy">
    <template #default="{ itemsVisible, itemsInModal, hasModal }">
      <div class="tour-gallery-grid">
        <div
          v-for="n in cropBy"
          :key="n"
          class="tour-gallery-grid__item u-bg-cover u-clickable"
          :class="{ _counter: hasModal && n === cropBy }"
          @click="showPopupSlider(n - 1)"
        >
          <img
            class="tour-gallery-grid__img"
            :src="getGridImage(itemsVisible, n - 1)"
          >
          <more-photos-counter
            v-if="hasModal && n === cropBy"
            :count="itemsInModal.length - 1"
          />
        </div>
        <popup-photo-slider
          v-model="popups.slider"
          :photos="getPopupGallery"
          :initial-slide="initialSlide"
        />
      </div>
    </template>
  </gallery-cropped>
</template>

<script>
import { sizeMdMax } from "@/assets/js/utils/mq";
import GalleryCropped from "@/components/renderless/gallery-cropped/index.vue";
import MorePhotosCounter from "@/components/molecules/more-photos-counter/index.vue";
import PopupPhotoSlider from "@/components/molecules/popup-photo-slider/index.vue";
export default {
  components: {
    GalleryCropped,
    MorePhotosCounter,
    PopupPhotoSlider,
  },
  props: {
    gallery: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      popups: {
        slider: false,
      },
      initialSlide: 0,
    };
  },
  computed: {
    cropBy() {
      return this.sizeMdMax ? 3 : 5;
    },
    getPopupGallery() {
      return this.gallery.map(({ MEDIA_BIG }, index) => ({
        id: index,
        path: MEDIA_BIG
      }))
    },
    getPreviewGallery(){
      return this.gallery.map(({  MEDIA_THUMB, MEDIA_BIG }, index) => {
         return (index) ?
            {
              id: index,
              path: MEDIA_THUMB
            } :
           {
             id: index,
             path: MEDIA_BIG
           }
      })
    },
    sizeMdMax,
  },
  methods: {
    getGridImage(items, index) {
      return items[index]?.path;
    },
    showPopupSlider(index) {
      this.initialSlide = index;
      this.popups.slider = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.tour-gallery-grid {
  display: grid;
  grid-gap: 4px;
  grid-template-columns: 1fr 264px;
  grid-template-rows: repeat(2, 1fr);
  border-radius: 40px;
  overflow: hidden;

  @include mixin.size-lg-min() {
    grid-template-columns: 1fr repeat(2, 304px);
  }

  &__img{
    width:100%;
    height:100%;
    object-fit:cover;
    position: absolute;
  }

  &__item {
    background-color: var.$gray-light;
    position: relative;

    &:first-child {
      grid-row: 1 / 3;
    }

    &:not(:first-child) {
      height: 222px;
    }

    &:not(._counter) {
      &:hover {
        &::before {
          background: rgba(var.$pitch-black, 0.2);
        }
      }

      &::before {
        @include mixin.decor();
        @include mixin.full-pos(0);
        content: "";
        display: block;
        position: absolute;
        background: rgba(var.$pitch-black, 0);
        transition: var.$transition-slow;
      }
    }
  }
}
</style>
